<template>
    <div class="page">
        <div style="flex: 1;"></div>

        <div class="main">
            <img src="https://yujie-bio.oss-cn-hangzhou.aliyuncs.com/2026/01/08/9cc7f0f4ac4b43b7a42b67eafb53f254.png">
            <div class="label">账号</div>
            <el-input prefix-icon="el-icon-user" placeholder="请输入账号" v-model="account"></el-input>
            <div class="label">密码</div>
            <el-input prefix-icon="el-icon-lock" placeholder="请输入密码" v-model="password" show-password></el-input>
            <button @click="login">登录</button>
        </div>
        <div style="flex: 1;"></div>
        <div class="line3"> © 2025 杭州誉捷生物科技有限公司. 保留所有权利. 浙ICP备2025145214号-1</div>
    </div>
</template>
<script>
import { login } from '../api.js';
export default {
    data() {
        return {
            account: '',
            password: '',
            // account: '',
            // password: ''
        }
    },
    mounted() {
        const token = localStorage.getItem('token');
        if (token) {
            this.$router.replace({
                path: '/Manage'
            })
        }
    },
    methods: {
        login() {
            if (!this.account || !this.password) {
                this.$message({
                    duration: 1500,
                    type: 'error',
                    message: '请填写账号密码'
                });
                return
            }
            login({ account: this.account, password: this.password }).then(res => {
                if (res.code === 0) {
                    localStorage.setItem('token', res.data)
                    if (localStorage.getItem('token')) {
                        this.$message({
                            duration: 1500,
                            type: 'success',
                            message: '登录成功'
                        });
                        setTimeout(() => {
                            this.$router.replace({
                                path: '/Manage'
                            })
                        });
                    }
                }
            })
        }
    }
}
</script>
<style scoped lang="less">
.page {
    background-color: #f5f5f5;
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;

    .line3 {
        font-size: 14px;
        color: #6c7280;
        height: 30px;
        line-height: 30px;
    }

    .main {
        border-radius: 8px;
        width: 448px;
        padding: 32px;
        box-sizing: border-box;
        background-color: #fff;
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);

        img {
            width: 194px;
            margin: 0 auto;
            display: block;
        }

        button {
            background-color: #2769b4;
            width: 100%;
            padding: 8px 16px;
            box-sizing: border-box;
            font-size: 16px;
            color: #fff;
            border: none !important;
            cursor: pointer;
            border-radius: 4px;
            margin-top: 24px;
        }

        .label {
            color: #384151;
            font-size: 14px;
            margin-bottom: 8px;
            margin-top: 16px;
        }

        .title {
            font-size: 24px;
            color: #202937;
            font-weight: bold;
            text-align: center;
            margin-bottom: 24px;
        }
    }
}
</style>
